export default "__VITE_ASSET__PUdxBjeE__"